import { createRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { rootRoute } from '../__root'
import { LawyerLayout } from '@/components/lawyer/LawyerLayout'
import { AmadeusWebSocketProvider } from '@/contexts/AmadeusWebSocketContext'

function LawyerRootComponent() {
  const navigate = useNavigate()

  // Redirect /lawyer to /lawyer/dashboard
  useEffect(() => {
    if (window.location.pathname === '/lawyer' || window.location.pathname === '/lawyer/') {
      navigate({ to: '/lawyer/dashboard' })
    }
  }, [navigate])

  return (
    <AmadeusWebSocketProvider>
      <LawyerLayout>
        <Outlet />
      </LawyerLayout>
    </AmadeusWebSocketProvider>
  )
}

export const lawyerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/lawyer',
  component: LawyerRootComponent,
})
